// Activity sort order
export const NEWEST_FIRST = 'NEWEST_FIRST' as const;
export const OLDEST_FIRST = 'OLDEST_FIRST' as const;

export type ActivitySortOrderType = typeof NEWEST_FIRST | typeof OLDEST_FIRST;
